<template>
  <v-app>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
    </v-overlay>
    <router-view v-if="!overlay"></router-view>
  </v-app>
</template>

<script>
import {mapGetters, mapState} from 'vuex'
import store from './store'
import MainLayout from "@/components/layouts/MainLayout";

export default {
  name: 'App',
  components: {
    MainLayout
  },
  data() {
    return {
      overlay: true,
      isSignedUserInterval: false
    }
  },
  methods: {
    checkPeriodically() {
      // eslint-disable-next-line no-underscore-dangle
      if (this.$root._route.path.includes('login')) {
        return;
      }

      this.isSignedUserInterval = setInterval(async () => {
        const token = this.$cookies.get('accessToken');
        await store.dispatch('user/VerifyTokenEmailSave', token);
        if (!token || !store.state.user.verifyTokenEmail) {
          // eslint-disable-next-line no-alert
          localStorage.setItem('redirectUrl', this.$route.fullPath);
          alert('You have been signed out. Please login again');
          clearInterval(this.isSignedUserInterval);
          await this.$router.push('/login');
        }
      }, 60000);
    },
    async checkPermissions() {
      if (this.user[0]) {
        const path = this.$route.path.split('/');
        if (
            (path[1] === 'analytics'
                && !this.user[0].can('see_analytics_section')
                && !this.user[0].can('reports_affiliates_POV')
                && !this.user[0].can('reports_advertisers_POV')
                && !this.user[0].can('reports_both_POV')
            )
            || (path[1] === 'affiliates' && !this.user[0].can('see_affiliates_section'))
            || (path[1] === 'advertisers' && !this.user[0].can('see_advertisers_section'))
            || (path[1] === 'finance' && !this.user[0].can('see_finance_section'))
            || (path[1] === 'advertisers'
                && (path[2] === 'domains' || path[2] === 'domain')
                && !this.user[0].can('see_domains_budget')
            )
            || (path[1] === 'advertisers'
                && (path[2] === 'blocking' || path[2] === 'blocking')
                && !this.user[0].can('traffic_control_read')
                && !this.user[0].can('traffic_control_manage')
            )
            || (path[1] === 'advertisers'
                && (path[2] === 'offers' || path[2] === 'offer')
                && !this.user[0].can('manage_offers')
                && !this.user[0].can('read_offers')
            )
        ) {
          await this.$router.push('/403');
        }
      }
    },
    async getCommonData() {
      await store.dispatch('managers/saveAffiliateManagers');
    }
  },
  async created() {
    this.overlay = true;
    try {
      const token = this.$cookies.get('accessToken');

      if (token) {
        await store.dispatch('user/VerifyTokenEmailSave', token);

        if (!this.verifyTokenEmail) {
          this.$cookies.remove('accessToken');
          localStorage.setItem('redirectUrl', this.$route.fullPath);
          await this.$router.push('/login');
        } else {
          await store.dispatch('user/saveUserStore', this.verifyTokenEmail);
          // get data that can be used across all components like list of managers
          this.checkPermissions()
          await this.getCommonData()
        }
      } else {
        // eslint-disable-next-line no-underscore-dangle
        const checkPatch = this.$root._route.path.includes('successLogin') || this.$root._route.path.includes('errorLogin');

        if (!checkPatch) {
          if (this.$route.path !== '/login') {
            localStorage.setItem('redirectUrl', this.$route.fullPath);
            this.$router.push('/login')
          }
        }
      }
    } catch (err) {
      console.log(err);
      await this.$router.push('/login');
    } finally {
      this.overlay = false;
    }

    this.checkPeriodically();
  },
  destroyed() {
    clearInterval(this.isSignedUserInterval);
  },
  computed: {
    ...mapState('user', ['user', 'verifyTokenEmail']),
    ...mapState('managers', ['affiliateManagers']),
  },
}
</script>
